import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const HeaderCampaignOff: FC = () => {
  const { t } = useTranslation();

  return <div className="header-campaign-off-banner header-banner">{t('header.campaignOffBanner')}</div>;
};
